/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Hold_Review_DateInputs */

const en_orders_hold_review_date = /** @type {(inputs: Orders_Hold_Review_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold Review Date`)
};

const es_orders_hold_review_date = /** @type {(inputs: Orders_Hold_Review_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de revision`)
};

/**
* | output |
* | --- |
* | "Hold Review Date" |
*
* @param {Orders_Hold_Review_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_hold_review_date = /** @type {((inputs?: Orders_Hold_Review_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Hold_Review_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_hold_review_date(inputs)
	return es_orders_hold_review_date(inputs)
});